import React, {
  useReducer,
  createContext,
  useContext,
  useEffect,
  Fragment,
} from 'react';
import { useParams } from 'react-router-dom';
import TwoCards from '../../../../../../components/Card/TwoCards';
import DriverMainCard from './DriverMainCard';
import DriverFromCard from './DriverFormCard';
import { reducer, initialState } from './reducer';
import Chip from '@material-ui/core/Chip';
import green from '@material-ui/core/colors/green';
import blueGray from '@material-ui/core/colors/blueGrey';
import { store as mainStore } from '../../../../../../store';
import { fetchingTransactions } from './actions';
import useTitle from 'hooks/useTitle';

export const store = createContext(null);
const { Provider } = store;

const Driver = () => {
  var { id } = useParams();
  const [state, dispatch] = useReducer(reducer, initialState);
  const { state: mainState } = useContext(mainStore);
  const { itemsCountPerPage } = mainState.Props;
  const { driver } = state;
  useTitle(`${driver?.firstName || ''} ${driver?.lastName || ''}`);
  const {
    fetchingUserData,
    fetchingOrders,
    fetchingNotes,
    fetchingSms,
    fetchingMessages,
  } = state;

  const refetchUserData = async () => {
    const userData = await fetchingUserData(id);
    dispatch({
      type: 'LOAD',
      payload: { name: 'driver', value: userData },
    });
  };

  useEffect(() => {
    (async () => {
      const userData = await fetchingUserData(id);
      dispatch({
        type: 'LOAD',
        payload: { name: 'driver', value: userData },
      });
      const notes = await fetchingNotes(id);
      dispatch({ type: 'LOAD', payload: { name: 'notes', value: notes } });
      const orders = await fetchingOrders(id, 1, itemsCountPerPage);
      dispatch({ type: 'LOAD', payload: { name: 'orders', value: orders } });
      const transactions = await fetchingTransactions(id, 1, itemsCountPerPage);
      dispatch({
        type: 'LOAD',
        payload: { name: 'transactions', value: transactions },
      });
      // const allSms = await fetchingSms(id, 1, itemsCountPerPage);
      // dispatch({ type: 'LOAD', payload: { name: 'allSms', value: allSms } });
      const messages = await fetchingMessages(id, 1, itemsCountPerPage);
      dispatch({
        type: 'LOAD',
        payload: { name: 'messages', value: messages },
      });
    })();
  }, []);

  return (
    <Provider value={{ state, dispatch, refetchUserData }}>
      <TwoCards
        title={
          <Fragment>
            {driver
              ? driver.legal
                ? `${driver.company || ''}`
                : `${driver.firstName || ''} ${driver.lastName || ''}`
              : null}
            <Chip
              variant="outlined"
              color="secondary"
              size="small"
              label={driver && driver.online ? `آنلاین` : `آفلاین`}
              style={{
                marginRight: 5,
                color: driver && driver.online ? green[500] : blueGray[500],
                borderColor:
                  driver && driver.online ? green[500] : blueGray[500],
              }}
            />
          </Fragment>
        }
        secondaryContent={<DriverFromCard />}
      >
        <DriverMainCard />
      </TwoCards>
    </Provider>
  );
};

export default React.memo(Driver);
